export default __webpack_public_path__ + "static/media/logo-main.af506114.jpg";